import BApp from "../../Modules/BApp";
import BRequest from "../../Modules/BRequest";
import BDiaryDayMealForm from "./BDiaryDayMealForm";
import BDiaryDaySearch from "./BDiaryDaySearch";

export default class BDiaryDayMealSearch extends BDiaryDaySearch
{
	getDiaryDayMealForm()
	{
		return new BDiaryDayMealForm(this.el.closest('.profile-diary-day-meal-form'));
	}

	createEntry(diaryDaySearchResult)
	{
		let diaryDayMealForm = this.getDiaryDayMealForm();

		let url = this.getAddUrl();
		let data = {
			...this.getDiaryDayMealForm().getForm().getData(),
			diaryDayMealId: diaryDayMealForm.getDiaryDayMealId(),
			ingredientId: diaryDaySearchResult.getObjectId(),
			practicalUnitId: diaryDaySearchResult.getPracticalUnitId(),
			amount: diaryDaySearchResult.getAmount(),
		};

		this.resetTerm();
		this.hideResults();

		BRequest.post(url, data).then(response => {
			diaryDayMealForm.addEntryHtml(response.data.templates.diaryDayMealIngredient);
			diaryDayMealForm.updateValues(response.data.values);
		}).finally(() => {
			BApp.refresh();
		});
	}
}
